export enum PublishedStateEnum {
  PUBLISHED = 'Published',
  UNPUBLISHED = 'Unpublished',
  NOT_PUBLISHED_YET = 'Not published yet',
}
